import React from "react"
import PropTypes from "prop-types"
import { DEFAULTS } from "@constants"
import { GLOBALS } from "@src/config"
import { Status } from "@bitcine/cs-theme"
import dayjs from "dayjs"
import Logo from "@src/public/logo.inline.svg"
import ExpiryDateTimePicker from "../../helpers/expiryDatetimePicker"

class Extension extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      status: "PENDING"
    }
  }
  componentDidMount() {
    this.api("GET", `${GLOBALS.API_URL}/shared-screeners/${this.props.match.params.sharedScreenerID}`, null, res =>
      this.setState({
        sharedScreener: res.sharedScreener,
        screenerName: res.name,
        sharedTo: `${res.sharedScreener.shared_name}${res.sharedScreener.shared_email ? ` (${res.sharedScreener.shared_email})` : ""}`,
        status: "READY"
      })
    )
  }
  extend(availableAt, expiry, notifyReviewer) {
    this.setState({ status: "PENDING", newAvailability: availableAt, newExpiry: expiry }, () => {
      this.api(
        "PUT",
        `${GLOBALS.API_URL}/shared-screeners/${this.props.match.params.sharedScreenerID}/update-dates`,
        JSON.stringify({
          availableAt,
          expiry,
          notifyReviewer
        }),
        res => this.setState({ status: "SUCCESS" })
      )
    })
  }
  api(method, url, body, callback) {
    fetch(url, { ...DEFAULTS, method, body })
      .then(res => {
        if (!res.ok) throw new Error(res.status)
        return res.json()
      })
      .then(res => callback(res))
      .catch(err => this.setState({ status: "ERROR" }))
  }
  render() {
    const { status, screenerName, sharedTo } = this.state
    return (
      <div
        style={{ zIndex: "10" }}
        /*
          This page in the app needs to be reponsive
          Since none of the app is responsive, setting this page as fixed above other components is a temp solution
        */
        className='fixed top-0 right-0 left-0 bottom-0 bg-gray-6 flex items-center justify-center p2'>
        <Status
          pending={status === "PENDING"}
          error={status === "ERROR"}>
          <div className='max-width-3 center mx-auto p4 relative col-12 rounded bg-white box-shadow'>
            <div className='bg-white fixed top-0 left-0 right-0'>
              <Logo className='mt2 mb1' style={{ maxWidth: "110px", maxHeight: "50px" }}/>
            </div>
            <h4>{screenerName}</h4>
            <div className='mb2'>
              {sharedTo}
            </div>
            {status === "SUCCESS" ? <div className="mx4 mt1 p2">
              <span style={{ fontSize: "38px" }} className='material-icons green'>
                check_circle_outline
              </span>
              <div>
                You have successfully updated the available date to <b>{this.state.newAvailability ? dayjs.utc(this.state.newAvailability).local().format("MMM D, YYYY [at] h:mma") : 'available immediately'}</b> and the expiry date to <b>{this.state.newExpiry ? dayjs.utc(this.state.newExpiry).local().format("MMM D, YYYY [at] h:mma") : 'never expire'}</b>.
              </div>
            </div>
            : <div>
              <div className='mb2'>
                You can update the availability and expiry dates for this screener below.
              </div>
              <div>
                <ExpiryDateTimePicker sharedScreener={this.state.sharedScreener} onSave={(availableAt, expiry, notifyReviewer) => this.extend(availableAt, expiry, notifyReviewer)}/>
              </div>
            </div>}
          </div>
        </Status>
      </div>
    )
  }
}

Extension.propTypes = {
  match: PropTypes.object.isRequired
}

export default Extension
